import { render, staticRenderFns } from "./sub-task-details.vue?vue&type=template&id=673e1154&scoped=true&"
import script from "./sub-task-details.vue?vue&type=script&lang=js&"
export * from "./sub-task-details.vue?vue&type=script&lang=js&"
import style0 from "./sub-task-details.vue?vue&type=style&index=0&id=673e1154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e1154",
  null
  
)

export default component.exports